if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form) {
				document.addEventListener('DOMContentLoaded', () => {
					this.form.querySelector('[name=id]').disabled = false
				})
				this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
			} else {
				console.warn('Form with ID #product-form not found.')
			}

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

     const formData = new FormData(this.form);

/* =========================================================
   SIERRA DE MORA - SERVICIOS DE CORTE JAMÓN / PALETA
========================================================= */

const SERVICE_VARIANTS = {
  jamon: {
    mazas: 65980114272605,
    maquina: 65980115026269,
    cuchillo: 65980116730205
  },
  paleta: {
    mazas: 65980661465437,
    maquina: 65980663595357
  }
};

const productTitle =
  document.querySelector('h1')?.textContent?.trim().toLowerCase() || '';

const esPaleta = productTitle.includes('paleta');

const jamonVariantId = Number(formData.get('id'));
const quantity = Number(formData.get('quantity') || 1);

let tipoCorte = '';

const productContainer =
  this.closest('.product-section') ||
  this.closest('.product-information') ||
  this.closest('section') ||
  document;

productContainer.querySelectorAll('input:checked, select').forEach((input) => {
  const name = (input.name || '').toLowerCase();

  if (
    name.includes('tipo de corte') ||
    name.includes('tipo-de-corte') ||
    name.includes('tipo_corte')
  ) {
    tipoCorte = input.value || '';
  }
});

/*
  Fallback por si el selector de variantes
  está fuera del propio product-form
*/
if (!tipoCorte) {
  document.querySelectorAll('input:checked, select').forEach((input) => {
    const name = (input.name || '').toLowerCase();

    if (
      name.includes('tipo de corte') ||
      name.includes('tipo-de-corte') ||
      name.includes('tipo_corte')
    ) {
      tipoCorte = input.value || '';
    }
  });
}

const tipoCorteNormalizado = tipoCorte
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '');

let serviceVariantId = null;

/* ==============================
   PALETAS
============================== */

if (esPaleta) {

  if (tipoCorteNormalizado.includes('maquina')) {
    serviceVariantId = SERVICE_VARIANTS.paleta.maquina;
  }

  if (tipoCorteNormalizado.includes('mazas')) {
    serviceVariantId = SERVICE_VARIANTS.paleta.mazas;
  }

/* ==============================
   JAMONES
============================== */

} else {

  if (tipoCorteNormalizado.includes('loncheado a maquina')) {
    serviceVariantId = SERVICE_VARIANTS.jamon.maquina;
  }

  if (tipoCorteNormalizado.includes('loncheado a cuchillo')) {
    serviceVariantId = SERVICE_VARIANTS.jamon.cuchillo;
  }

  if (tipoCorteNormalizado.includes('mazas')) {
    serviceVariantId = SERVICE_VARIANTS.jamon.mazas;
  }

}

/* ==============================
   AÑADIR AL CARRITO
============================== */

if (serviceVariantId) {

  const items = [
    {
      id: jamonVariantId,
      quantity: quantity
    },
    {
      id: serviceVariantId,
      quantity: quantity
    }
  ];

  const body = {
    items: items
  };

  if (this.cart) {
    body.sections = this.cart
      .getSectionsToRender()
      .map((section) => section.id);

    body.sections_url = window.location.pathname;

    this.cart.setActiveElement(document.activeElement);
  }

  config.headers['Content-Type'] = 'application/json';
  config.body = JSON.stringify(body);

} else {

  if (this.cart) {
    formData.append(
      'sections',
      this.cart.getSectionsToRender().map((section) => section.id)
    );

    formData.append('sections_url', window.location.pathname);

    this.cart.setActiveElement(document.activeElement);
  }

  config.body = formData;
}

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {

            // dispatch cart:error
            document.dispatchEvent(
              new CustomEvent("cart:error", {
                detail: {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                },
              })
            );

            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          // dispatch variant:add when fetch fail
          document.dispatchEvent(
            new CustomEvent("variant:add", {
              detail: {
                variant: {
                  id: formData.get("id"),
                },
                quantity: Number(formData.get("quantity") || 1),
                formElement: this.form,
                sectionId: this.dataset.source,
              },
            })
          );

          fetch(`${routes.cart_url}.js`)
						.then((response) => {
							return response.text()
						})
						.then((state) => {
							const parsedState = JSON.parse(state)

							// dispatch cart:change for the entire basket
							document.dispatchEvent(
								new CustomEvent('cart:change', {
									detail: {
										cart: parsedState,
										sectionId: this.dataset.source,
									},
								})
							)
						})
						.catch((error) => {
							console.error('Error fetching cart state:', error);
						})

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
